import { cn } from '@goaltree/ui/lib/utils'
import type { ReactNode } from 'react'

export function TodaySectionHeader({
  label,
  count,
  trailing,
  className,
}: {
  label: string
  count?: string
  trailing?: ReactNode
  className?: string
}) {
  return (
    <div
      className={cn(
        'mt-2 mb-1 flex items-baseline gap-1.5 text-[10px] font-bold uppercase tracking-widest text-muted-foreground/60',
        className,
      )}
    >
      {label}
      {count && (
        <span className="ml-auto font-mono text-[11px] font-normal normal-case tracking-normal tabular-nums">
          {count}
        </span>
      )}
      {trailing && <span className="ml-auto self-center">{trailing}</span>}
    </div>
  )
}
